import React, { Suspense } from 'react';
import styled from 'styled-components/macro';
import { Canvas } from '@react-three/fiber';
import { PerspectiveCamera } from '@react-three/drei';

import Scene from './Scene';

const Wrapper = styled.div`
  position: absolute;
  z-index: 2;

  height: 100%;
  width: 100vw;
  clip-path: inset(0 0);
`;

const Container = styled.div`
  position: fixed;
  height: 100vh;
  width: 100%;
  top: 0;
`;

const WebGL = React.forwardRef(({ }, ref: React.ForwardedRef<HTMLDivElement>) => (
  <Wrapper>
    <Container ref={ref}>
      <Canvas
        style={{
          top: "50%",
          transform: "translateY(-50%)"
        }}
      >
        <ambientLight intensity={0.6} />
        <directionalLight intensity={0.15} position={[-10, 6, 10]} />

        <PerspectiveCamera fov={20} position={[0, 0, 20]} makeDefault />

        <Suspense fallback={null}>
          <Scene />
        </Suspense>
      </Canvas>
    </Container>
  </Wrapper>
));

export default WebGL;